import { render, staticRenderFns } from "./Sellprint.vue?vue&type=template&id=587e4e0c&scoped=true&"
import script from "./Sellprint.vue?vue&type=script&lang=js&"
export * from "./Sellprint.vue?vue&type=script&lang=js&"
import style1 from "./Sellprint.vue?vue&type=style&index=1&id=587e4e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e4e0c",
  null
  
)

export default component.exports